export default "__VITE_ASSET__H51ILScO__"